import { useEffect } from 'react';

export const rescheduleTheme = {
  brand: '#135635',
  brandHover: '#0C3A23',
  brandTint: '#E7F0EA',
  surfaceMuted: '#F5F8F6',
  text: '#14201A',
  textMuted: '#55655C',
  border: '#D5E0D9',
  divider: '#E6ECE8',
  disabledFill: '#C9D4CD',
  disabledText: '#5F6F66',
  warnBg: '#FDF1DF',
  warnInk: '#7A4206',
  errorBorder: '#C4473A',
  errorInk: '#A1322A',
  font: "'Rubik', system-ui, sans-serif",
  radii: { frame: 14, frameMobile: 16, card: 12, cardMobile: 10, control: 10 },
} as const;

export const phoneMediaQuery = '(max-width:639px)';

const RUBIK_FONT_LINK_ID = 'rescheduleRubikFont';
const RUBIK_FONT_URL = 'https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700&display=swap';

export const useRubikFont = () => {
  useEffect(() => {
    if (document.getElementById(RUBIK_FONT_LINK_ID)) {
      return;
    }
    const link = document.createElement('link');
    link.id = RUBIK_FONT_LINK_ID;
    link.rel = 'stylesheet';
    link.href = RUBIK_FONT_URL;
    document.head.appendChild(link);
  }, []);
};
